import { render, staticRenderFns } from "./FollowupReports.vue?vue&type=template&id=71938c3a"
import script from "./FollowupReports.vue?vue&type=script&lang=js"
export * from "./FollowupReports.vue?vue&type=script&lang=js"
import style0 from "./FollowupReports.vue?vue&type=style&index=0&id=71938c3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports